<template lang="pug">
  y-chip.d-block.py-1(v-if="offerItem" color="success100")
    .d-flex.align-center.justify-space-between
      div.d-flex.align-center
        v-icon.mr-2(size="15" color="success500") $yzi-check-circle
        v-tooltip(top color="black" content-class="black tooltip-top-arrow")
          template(#activator="{ on, attrs }")
            div(v-bind="attrs" v-on="on")
              .text-sm.neutral700--text.mr-2.clickable.ellipsis-text-1 {{ offerItem.offer.name }}
          div(style="max-width: 30vw; min-width: 60px;")
            .text-sm.white--text {{ offerItem.offer.name }}
        v-progress-circular(v-if="isLoading" size="15" width="2" color="neutral700" indeterminate)
        .text-xxs.underline.font-semibold.hover-bg(v-else @click="openDeleteDialog = true") REMOVE
      div
        .text-sm.neutral700--text.no-wrap.ml-2 - {{ offerItem.reward.discount_amount | displayPrice }}
    .dialog
      delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @delete="handleRemove")
        .text-lg.font-medium.mb-4 Are you sure you want to remove this offer?
        v-sheet.info100.round-xl.pa-4
          .text-md.font-semibold {{ offerItem.offer.name }}
          .text-sm Discount: {{ offerItem.reward.discount_amount | displayPrice }}
        .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DeleteConfirmationDialog from "@/components/clinic/dialogs/DeleteConfirmationDialog.vue";

export default {
  components: {
    DeleteConfirmationDialog
  },
  props: {
    offerItem: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isLoading: false,
      openDeleteDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    async handleRemove() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/redeems/${this.offerItem.id}`
        await this.$axios.delete(url)
        this.updateActivityLog(url, null, null, 'DELETE', this.offerItem.id, `leadId: ${this.offerItem.lead}`)
        this.$emit('updated')
        this.showMessage(['success', 'Offer removed successfully'])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
        this.openDeleteDialog = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id, objectRef) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: objectRef || null,
        activity: 'Delete redeem offer',
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>


<style scoped>
</style>